import { render, staticRenderFns } from "./QuizGameOver.vue?vue&type=template&id=35873d91&scoped=true&"
import script from "./QuizGameOver.vue?vue&type=script&lang=js&"
export * from "./QuizGameOver.vue?vue&type=script&lang=js&"
import style0 from "./QuizGameOver.vue?vue&type=style&index=0&id=35873d91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35873d91",
  null
  
)

export default component.exports